import React from 'react';
import Navbar from '../components/navbar';
import Rotas from './rotas';
import ProvedorAutenticacao from './provedorAutenticacao';

import 'bootswatch/dist/flatly/bootstrap.css';
import '../custom.css';
import 'toastr/build/toastr.css';
import 'toastr/build/toastr.min.js';

class App extends React.Component {
  render() {
    return (
      <ProvedorAutenticacao>
        <Navbar>
          <Rotas />
        </Navbar>
      </ProvedorAutenticacao>
    );
  }
}

export default App;